module.exports = __webpack_public_path__ + "img/1_of_Diamonds.svg.eecc7580.png";